module.exports = __webpack_public_path__ + "img/184.48ee3aaa.jpg";